import React, { createContext, useContext, useState, useCallback } from 'react';
import { logoutAdmin, isLoggedIn, isTokenExpired, getToken } from '../utils/auth';

const TokenExpirationContext = createContext();

export const useTokenExpiration = () => {
  const context = useContext(TokenExpirationContext);
  if (!context) {
    throw new Error('useTokenExpiration must be used within TokenExpirationProvider');
  }
  return context;
};

export const TokenExpirationProvider = ({ children }) => {
  const [showExpiredModal, setShowExpiredModal] = useState(false);

  const handleTokenExpired = useCallback(() => {

    const token = getToken();
    const isExpired = isTokenExpired(token);
    if (isExpired) {
      setShowExpiredModal(true);
    }
  }, []);

  const handleLoginRedirect = useCallback(() => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    setShowExpiredModal(false);
    window.location.href = '/';
  }, []);

  const value = {
    showExpiredModal,
    handleTokenExpired,
    handleLoginRedirect,
    setShowExpiredModal
  };

  return (
    <TokenExpirationContext.Provider value={value}>
      {children}
    </TokenExpirationContext.Provider>
  );
};